import { reducer, initialStateBase } from './newCollection';

export const urls = {
    getSuggestions: '/api/autocomplete/autosuggest/v2',
    getSearchSuggestions: '/api/searchSuggestions'
};

export const initialState = {
    ...initialStateBase,
    metadataKey: 'suggestions',
    lastCollectionUrl: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_SUGGESTIONS': {
            const headers = action.responseHeaders;
            const requestID = (headers && headers.map && headers.map['x-request-id'] && headers.map['x-request-id'][0]) || '';

            // Add x-request-id from headers to data, so it can be sent in tracking
            const newAction = {
                ...action,
                data: {
                    ...action.data,
                    data: {
                        ...action.data.data,
                        'x-request-id': requestID
                    }
                }
            };

            const newState = {
                ...state,
                lastCollectionUrl: action.url
            };

            return reducer(newState, newAction, 'SUGGESTIONS');
        }
        default:
            return state;
    }
};
